import IuHomeBase from "../../SHARED/components/IuHomeBase";

const SimpleUserHome = () => <IuHomeBase />;

export default SimpleUserHome;
